// extracted by mini-css-extract-plugin
export var disable = "Pagination-module--disable--fhBRq";
export var next = "Pagination-module--next--HKuPy";
export var nextLink = "Pagination-module--nextLink--Uy-6W";
export var pagination = "Pagination-module--pagination--1hy6+";
export var previous = "Pagination-module--previous--Sna5M";
export var previousLink = "Pagination-module--previousLink--VZDX6";